import React, { useEffect } from 'react'

import { Button } from '@/components/Button'
import {
  DialogTrigger,
  Modal,
  Dialog,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from '@/components/Modal'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { recommenderSettingsQuery } from '@/api/settings'
import { useQuery } from '@tanstack/react-query'
import { RecommenderSettingsForm } from '@/features/RecommenderSettingsForm/RecommenderSettingsForm'
import { RecommenderSettings } from '@/api/types'

type Props = {
  recommenderSettings: RecommenderSettings | undefined
  setRecommenderSettings: (settings: RecommenderSettings | undefined) => void
}
export default function RecommenderSettingsDialog({
  recommenderSettings,
  setRecommenderSettings,
}: Props) {
  const { data } = useQuery(recommenderSettingsQuery)

  useEffect(() => {
    if (data) {
      setRecommenderSettings(data)
    }
  }, [data])

  function handleReset(close: () => void) {
    setRecommenderSettings(data)
    close()
  }

  return (
    <DialogTrigger>
      <Button variant="icon">
        <FontAwesomeIcon icon={faGear} />
      </Button>
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <ModalHeader onClose={close}>Recommender Settings</ModalHeader>

              <ModalContent>
                {recommenderSettings && (
                  <RecommenderSettingsForm
                    recommenderSettings={recommenderSettings}
                    setRecommenderSettings={setRecommenderSettings}
                  />
                )}
              </ModalContent>
              <ModalFooter>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                  <Button onPress={close}>Dismiss</Button>

                  <div style={{ display: 'flex', gap: 10 }}>
                    <Button onPress={() => handleReset(close)} type="reset">
                      Reset
                    </Button>
                    <Button variant="primary" onPress={close}>
                      Apply
                    </Button>
                  </div>
                </div>
              </ModalFooter>
            </>
          )}
        </Dialog>
      </Modal>
    </DialogTrigger>
  )
}
